import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";

import { GET_EDU_USER, UPDATE_EDU } from "actions/ActionTypes";
import EDUAdminForm from "components/edu/EDUAdminForm";

import { getApi, putApi } from "actions/SendActions";

import "css/admin/smartlist.scss";

function EDUAdminUpdateUI({ t }) {
  const dispatch = useDispatch();
  const { id, projectSlug } = useParams();
  const { edus } = useSelector((state) => state.fetchReducer);
  const { token } = useSelector((state) => state.loginReducer);

  const index = edus && edus.isFetched && edus.indexes.uuid[id];

  const [edu, setEdu] = useState(index ? edus.data[index[0]] : null);

  useEffect(() => {
    if (edus.isFetched && (!edu || !edu.isFetched)) {
      getEdu(id, token);
    }
  }, [edu, index]);

  const getEdu = (uuid, token) => {
    dispatch(
      getApi({
        endpoint: `/api/user/v3/admin/users/${uuid}`,
        type: GET_EDU_USER,
        item: "edus",
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        callback: (edu) => {
          setEdu(edu);
        },
      }),
    );
  };

  const onSubmit = (uuid, data, token, t) => {
    dispatch(
      putApi({
        endpoint: `/api/user/v3/admin/users/edu/${uuid}`,
        type: UPDATE_EDU,
        item: "edus",
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        data,
        message: t("editor-notif:saveSuccess"),
        error: t("editor-notif:saveError"),
      }),
    );
  };

  const onUpdate = (item) => {
    if (item.avatar) delete item.avatar_url;

    onSubmit(item.uuid, item, token, t);
  };

  if (!edus || edus.data.length === 0 || !projectSlug || !edu) {
    return null;
  }

  return <EDUAdminForm item={edu} onSubmit={onUpdate} type="edit" />;
}

EDUAdminUpdateUI.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-edu", "editor-errors")(EDUAdminUpdateUI);
